// extracted by mini-css-extract-plugin
module.exports = {"bulletPointSection":"styles_bulletPointSection__uUvRp"};